<template>
  <MapPopup
      v-if="object"
      icon="icon-object"
      :title="object.name"
      :data="mainData"
      :secondary-data="secondaryData"
      :actions="object.config?.actions"
      :progress="object.loading"
      :lat="object.lat"
      :lng="object.lng"
      show-tabs
      @close="emit('close')"
  >
    <div class="map-popup__row">
      <span class="label">
        {{ $t('front.address') }}
      </span>

      <span class="value">
        <Address :lat="object.lat" :lng="object.lng" />
      </span>
    </div>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import {computed, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import { googleMapUrl } from '@/js/helpers.js';
import Address from "@/js/Elements/Address.vue";
import axios from "axios";

const store = useStore();
const props = defineProps({
  id: Number,
});
const { t } = useI18n();
const emit = defineEmits(['close']);
const object = computed(() => store.getters['object/find'](props.id));
const selectedObjectId = computed(() => store.getters['object/selected']);
const layer = computed(() => store.getters['object/layerGroup'].findLayer(props.id));
const units = computed(() => store.getters['settings/units']);
const iso = computed(() => store.getters['app/iso']);
const sharingHash = computed(() => store.getters['auth/sharingHash']);
let manualUpdate = !selectedObjectId.value || store.getters['object/hash'];

onBeforeUnmount(() => {
  if (manualUpdate) {
    store.commit('object/updateFullObject', null);
  }
});

if (manualUpdate) {
  store.dispatch('object/updateFullObject', props.id);
}

if (!sharingHash.value) {
  axios.get('/payload/map/object-actions', {
    params: { device_id: object.value.id}
  }).then((response) => {
    store.commit('object/updateInList', response.data.data[0]);
  });
}

const mainData = computed(() => {
  const data = [
    { title: t('front.time'), value: object.value.time },
    { title: t('front.stop_duration'), value: object.value.stop_duration },
  ];

  if (object.value?.sensors) {
    object.value.sensors.forEach(s => data.push(s));
  }

  if (object.value?.expiration_date) {
    data.push({
      title: t('front.expiration_date'),
      value: object.value.expiration_date
    })
  }
  return data;
});

const secondaryData = computed(() => {
  const data = [
    {
      title: t('front.position'),
      value: `<a href="${googleMapUrl(object.value.lat, object.value.lng)}" target="_blank">${object.value.lat}&deg;,${object.value.lng}&deg;</a>`,
    }, {
      title: t('front.altitude'),
      value: object.value.altitude || '-'
    }, {
      title: t('front.angle'),
      value: layer.value ? layer.value.getFormattedAngle() : '-',
    }, {
      title: t('front.driver'),
      value: object.value?.driver?.name || '-'
    }, {
      title: t('front.model'),
      value: object.value?.model || '-'
    }, {
      title: t('front.plate'),
      value: object.value?.plate || '-'
    }, {
      title: t('front.protocol'),
      value: object.value?.protocol || '-'
    },
  ];

  if (object.value.services) {
    object.value.services.forEach(s => data.push(s));
  }

  return data;
});
</script>
